<template>
  <div id="app">
    <div v-if="getShow == '404'">
        <NotFound/>
    </div>
    <div v-else id="app-wrapper">
      <Navbar ref="navbar" :highlight="getShow" @nav-click="changeNav" @theme-change="toggleDark()"/>
      <div id="app-body">
        <div v-if="getShow == 'home'" id="home">
          <Home/>
        </div>
        <div v-else-if="getShow == 'about'" id="about">
          <About/>
        </div>
        <Footer/>
      </div>
    </div>
  </div>
</template>

<script>

import Home from "./views/Home.vue";
import About from "./views/About.vue";
import NotFound from "./views/404.vue";
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";

import Cookies from 'js-cookie';

export default {
  name: "App",
  components: {
    Navbar,
    Home,
    About,
    Footer,
    NotFound
  },
  data: () => {
    return {
      isDark: false,
      show: "home",
      supportedShows: [
        'home',
        'about'
      ],
      defaultTitle: document.title,
      baseUrl: window.location.origin + '/'
    }
  },
  methods: {
    changeNav(toWhere) {
      /**
       * Listen to navigation clicks, change the navigation, if the current
       * view is not the same as the passed one.
       */
      if (toWhere == "") toWhere = "home";

      if (toWhere == this.show) return;

      // Put a check to see if the show is valid, else
      // redirect to Not found page.
      if (!this.supportedShows.includes(toWhere)) toWhere = "404"
      this.show = toWhere;
      this.changeTitleUrl(toWhere);
    },
    changeTitleUrl(toEndpoint) {
      /**
       * Since we are changing the views manually on user clicks,
       * we also need to change the title and add the new url to the
       * browsers history.
       */
      let toTitle = this.defaultTitle;
      let finalEndpoint = this.baseUrl;
      if (toEndpoint != "home") {
        toTitle = toEndpoint[0].toUpperCase() + toEndpoint.slice(1) + " | " + this.defaultTitle;
        finalEndpoint += toEndpoint;
      }
      document.title = toTitle;
      history.pushState({id: toEndpoint}, toTitle, finalEndpoint);
    },
    showCurrentPageView() {
      /**
       * Method to be called on load of the page and
       * check what the current page endpoint is.
       * 
       * If the enpoint is nothing then show the home view.
       * If it is about, show about view, etc.
       */
      let currentLocation = document.location.toString().split("/");
      const currentEndpoint = currentLocation[currentLocation.length - 1];
      this.changeNav(currentEndpoint);
    },
    isVisible(elem) {
      // Check if the passed element is visible.
      // Code from jQuery sources.
      return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
    },
    animateOnLoad() {
      document.getElementsByClassName('fadeInUp').forEach((el, index) => {
        if (!this.isVisible(el)) return;
        el.style.animationDelay = `${0.5 + index * 0.1}s`;
      })
    },
    toggleDark() {
      const body = document.getElementsByTagName('body')[0];
      this.isDark ? body.classList.remove('dark-body') : body.classList.add('dark-body');
      this.isDark = !this.isDark;
      this.$refs.navbar.toggleThemeIcon();
      this.setCookie();
    },
    setCookie() {
      // Set the cookie
      Cookies.set('current-theme', this.isDark ? 'dark' : 'light');
    },
    checkCookie() {
      // Check cookie to set the theme.
      const themeSet = Cookies.get('current-theme');
      // If the cookie was not set, it will be undefined.
      if (themeSet == undefined) return this.setCookie();

      // If it is available, check which theme
      if (themeSet == 'light') return;
      else if (themeSet == 'dark') this.toggleDark();
    }
  },
  computed: {
    getShow() {
      return this.show;
    }
  },
  mounted() {
    this.showCurrentPageView();
    this.animateOnLoad();
    this.checkCookie();
  },
  updated() {
    this.animateOnLoad();
  }
};
</script>

<style lang="scss">
#app {
  font-family: 'Jost', sans-serif;

  #app-body {
    margin-left: 6rem;
  }
}

.song-container {
  #song {
    height: inherit;
  }
}

@media only screen and (max-width: 468px)  {
  #app #app-body {
    margin-left: 0;
    margin-top: 3rem;
  }
}
</style>
